import React from "react";
import Switch from "@/component/Switch";
import { playRateList } from "@/constants/playrate";
import StepSlider from "@/component/StepSlider";
import { morePanelId } from "@/pages/App/pages/AppSummary/const";
import "./index.css";
import BottomActionSheet from "@/component/BottomActionSheet";

interface IProps {
  skipBlank: boolean;
  setSkipBlank: (skipBlank: boolean) => void;
  playRate: string;
  setPlayRate: (playRate: string) => void;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  showSkipBlank?: boolean;
}

const MobileMorePanel: React.FC<IProps> = ({
  playRate,
  setPlayRate,
  visible,
  setVisible,
  skipBlank,
  setSkipBlank,
  showSkipBlank = false,
}) => {
  const handleChangeSkipBlank = (skipBlank: boolean) => {
    setSkipBlank(skipBlank);
  };

  return (
    <div id={morePanelId}>
      <BottomActionSheet visible={visible} setVisible={setVisible} title="设 置">
        <div className="px-6 pb-6 text-mx-secondary text-3.5 line-height-5">
          {!showSkipBlank && (
            <div className="flex py-3.75 items-center justify-between">
              跳过空白片段
              <Switch
                className="w-10"
                checked={skipBlank}
                onChange={handleChangeSkipBlank}
              />
            </div>
          )}
          <div className="py-3.75">倍速调整</div>
          <StepSlider
            value={playRate}
            onChange={setPlayRate}
            list={playRateList}
          />
        </div>
      </BottomActionSheet>
    </div>
  );
};

export default MobileMorePanel;
